export default "__VITE_ASSET__D347vyPa__"